var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 17",
    style: {
      enableBackground: "new 0 0 12 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2,3.7V3.6h1.9l1-3.1H0.3l1,3.1h1.9v0.1c0,0.9-0.2,1.7-0.6,2.6l-1.9,3.8l5.5,7.8l5.4-7.8L9.8,6.3 C9.4,5.4,9.2,4.6,9.2,3.7z M1.7,1.5h9l-0.4,1.1H2.1L1.7,1.5z M6.7,15.4v-4.5C7,10.8,7.3,10.4,7.3,10c0-0.6-0.5-1-1-1s-1,0.5-1,1 c0,0.4,0.2,0.7,0.5,0.9v4.5L1.9,10l1.6-3.3c0.5-1,0.7-2,0.7-3V3.6h3.9v0.1c0,1,0.2,2,0.7,3l1.6,3.3L6.7,15.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.2cd100ddd90ee0a15ced1d4bd861b3b6.svg";
export { ForwardRef as ReactComponent };